import useFetch from '@hooks/useFetch';
import useMyInfo from '../auth/useMyInfo';
import { getMeUid } from '../../selectors/auth';

const useClassroomConsumption = (shouldFetch = true) => {
  const meUID = useMyInfo(getMeUid);
  const { data: classroomConsumption, ...rest } = useFetch(
    shouldFetch && meUID
      ? `v1/user/${meUID}/watch_time/progress/?is_limit_special_class_consumption_exp=True`
      : null
  );
  return { classroomConsumption, ...rest };
};

export default useClassroomConsumption;
